// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + {"56":"badge-lib","7583":"member-card-async-frameless"}[chunkId] + ".chunk.min.css";
};